import clsx from "clsx";
import { Popover } from "@headlessui/react";
import { DateSelector } from "./DateSelector";
import { getFullDate } from "./helpers";
import { State } from "@Light/utils/state";
import { useScaffold } from "@Light/scaffold";
import { WithPopover } from "@Light/components/page/popover/WithPopover";
import { captureEvent } from "@Light/app/analytics";

function CalendarIcon(props: React.ComponentPropsWithoutRef<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5 8.33317H2.5M13.3333 1.6665V4.99984M6.66667 1.6665V4.99984M6.5 18.3332H13.5C14.9001 18.3332 15.6002 18.3332 16.135 18.0607C16.6054 17.821 16.9878 17.4386 17.2275 16.9681C17.5 16.4334 17.5 15.7333 17.5 14.3332V7.33317C17.5 5.93304 17.5 5.23297 17.2275 4.69819C16.9878 4.22779 16.6054 3.84534 16.135 3.60565C15.6002 3.33317 14.9001 3.33317 13.5 3.33317H6.5C5.09987 3.33317 4.3998 3.33317 3.86502 3.60565C3.39462 3.84534 3.01217 4.22779 2.77248 4.69819C2.5 5.23297 2.5 5.93304 2.5 7.33317V14.3332C2.5 15.7333 2.5 16.4334 2.77248 16.9681C3.01217 17.4386 3.39462 17.821 3.86502 18.0607C4.3998 18.3332 5.09987 18.3332 6.5 18.3332Z"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export type DatepickerProps = {
  className?: string;
  label?: string;
  selectedDate: State<string>;
  minSelectableDate: string;
  maxSelectableDate: string;
};

export const Datepicker: React.FC<DatepickerProps> = ({
  className,
  label,
  selectedDate,
  minSelectableDate,
  maxSelectableDate,
}: DatepickerProps) => {
  const scaffold = useScaffold();
  return (
    <WithPopover
      popover={
        <div className="p-6">
          <DateSelector
            selectedDate={selectedDate}
            minSelectableDate={minSelectableDate}
            maxSelectableDate={maxSelectableDate}
          />
        </div>
      }
    >
      {({ open }) => {
        const onClickOpen = () => {
          captureEvent("enroll_select_date_open");
          open();
        };

        return (
          <Popover.Button
            className={clsx(
              "rounded-md bg-white px-3 py-3 text-sm shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 w-full",
              className,
              scaffold.page.colors.text.primary,
            )}
            onClick={onClickOpen}
          >
            <div className="flex items-center gap-4">
              <CalendarIcon />
              <div className="flex flex-col items-start">
                {label ? (
                  <div
                    className={clsx(
                      "text-xs font-regular",
                      scaffold.page.colors.text.secondary,
                    )}
                  >
                    {label}
                  </div>
                ) : null}
                <div>{getFullDate(selectedDate.val)}</div>
              </div>
            </div>
          </Popover.Button>
        );
      }}
    </WithPopover>
  );
};
